<template>
<div class="mall-iot">
  <div class="content">
    <h2>IoT硬件设备</h2>
    <p>选择优质国产化IoT产品设备 <a href="javascript:;" @click="goAll">查看全部 ></a></p>
    <div class="list-box">
      <div class="card" v-for="item in replaceList" :key="item.id"  @click="replaceInfo(item)">
        <div class="card-img">
          <VImg :attachment-id="item.productCover"/>
        </div>
        <div class="content-card">
          <div>
            <div class="text-overflow">{{ item.productName }}</div>
            <p v-html="item.productBlurb" class="text-overflow3"></p>
          </div>
          <div class="bottom">
            <div>￥{{item.productPrice}}</div>
            <div class="text-overflow">
              <img src="@/assets/img/2.0/mall/company.png" alt="">
              {{item.pdtCorpName}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import VImg from '@/components/VImg.vue'
import {getDatNewProductList, getProductReplaceList} from '@/api/dat.js'

export default {
  name: "mallIot",
  components: {VImg},
  data(){
    return{
      page: {
        current: 1,
        size: 8,
        total: 0,
      },
      replaceList:[],
    }
  },
  methods:{
    loadGetIotProductList() {
      let { page } = this;
      let data = {
        status: 2,
      };
      getProductReplaceList(page, data).then((res) => {
        this.replaceList = res.records;
        this.page.total = res.total;
      });
    },
    goAll(){
      this.$router.push('/replace')
    },
    // 详情
    replaceInfo(item) {
      if(item.oldProductId){
        this.$router.push({
          path: "/replace/info",
          query: { id:item.oldProductId },
        });
      }else {
        this.$router.push({
          path: "/replace/newInfo",
          query: { id:item.id },
        });
      }
    },
  },
  mounted() {
    this.loadGetIotProductList()
  }
}
</script>


<style scoped lang="scss">
.mall-iot{
  background: url("../../../assets/img/2.0/mall/homeBg2.png") no-repeat;
  background-size: cover;
  .content{
    width: 1280px;
    margin: 0 auto;
    padding: 64px;
    display: flex;
    flex-direction: column;
    align-items: center;
    >h2{
      font-weight: 600;
      font-size: 32px;
      color: #262626;
      line-height: 45px;
      margin-bottom: 16px;
    }
    >P{
      font-weight: 400;
      font-size: 18px;
      color: #000000;
      line-height: 24px;
      >a{
        margin-left: 12px;
      }
    }
    >.list-box{
      margin-top: 44px;
      width: 1280px;
      display: flex;
      flex-wrap: wrap;
      >.card{
        width: 302px;
        height: 326px;
        background: #FFFFFF;
        padding: 0 24px;
        display: flex;
        flex-direction: column;
        cursor: pointer;
        .card-img{
          height: 152px;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px 0;
          >img{
            max-width: 100%;
            max-height: 100%;
          }
        }
        .content-card{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-bottom: 24px;
          >:first-child{
            >div{
              font-weight: 400;
              font-size: 16px;
              color: #262626;
              line-height: 22px;
              margin-bottom: 8px;
            }
            >p{
              font-weight: 400;
              font-size: 12px;
              color: #8C8C8C;
              line-height: 16px;
            }
          }
          >.bottom{
            >:first-child{
              font-weight: 400;
              font-size: 18px;
              color: #EA0B06;
              line-height: 24px;
              margin-bottom: 10px;
            }
            >:last-child{
              display: flex;
              align-items: center;
              font-weight: 400;
              font-size: 12px;
              color: #999999;
              line-height: 16px;
              >img{
                display: block;
                width: 14px;
                height: 14px;
                margin-right: 8px;
              }
            }
          }
        }
      }
      >:not(:nth-child(3n)){
        margin-right: 24px;
      }
      >:nth-child(-n+4){
        margin-bottom: 24px;
      }
    }
  }
}
</style>
